import { AWIN_MERCHANT_ID } from '@daymade/common-lib/affiliates';
import { initialiseAwinAdvertiserConsent } from 'api/CookieConsent';
import Script from 'next/script';
import { useEffect, useState } from 'react';

const AwinTag = () => {
  const [consentInitialised, setConsentInitialised] = useState(false);

  // Awin require the consent status to be set before the MasterTag loads
  useEffect(() => {
    initialiseAwinAdvertiserConsent();
    setConsentInitialised(true);
  }, []);

  if (!consentInitialised) return null;

  return (
    <Script
      id="awinMasterTag"
      src={`https://www.dwin1.com/${AWIN_MERCHANT_ID}.js`}
      defer
    />
  );
};

export default AwinTag;
